export default {
  //tabBar选择
  setActive(state,data){
    state.active = data
  },
  //设置当前选中的用户
  setUserInfo(state,data){
    state.userInfo  = data
  },
  //设置全部就诊人信息
  setUserInfoList(state,data){
    state.userInfoList  = data
  },
  //设置下拉框信息
  setUserDropList(state,data){
    state.userDropList  = data
  },
  setjssdk(state,data){
    state.jssdk  = data
  },
  setCheckUpDetail(state,data){
    state.checkUpDetail  = data
  },
  setCheckOutDetail(state,data){
    state.checkOutDetail  = data
  },
  commit_Info(state, data) {
    state.familyDocInfo = { ...state.familyDocInfo, ...data };
  },
  getName(state, name) {
    state.name = name
  },
  getActive(state, active) {
    state.active = active
  },
  // 医院信息
  setHosDetail(state, data){
    state.hosDetail = data
  },
  setGo(state, data){
    state.isGo = data
  },
  setDeptId(state, data){
    state.deptid = data
  },
// 帮扶专家列表信息 数据前端写死了需要做数据持久化
  // setDocList(state, data){
  //   state.docList = data
  // },
  // // 本院专家列表信息 数据前端写死了需要做数据持久化
  // setLocalDocList(state, data){
  //   state.docLocalList = data
  // },
  
  //保存首页的动态新闻
  setLocalDocList(state, data){
    state.docLocalList = data
  },
  setHosArticles(state,data){
    state.hosArticles = data

  },
}
